import * as React from "react";
function SvgIcTableColumnLocationsHidden(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.352 15.014a3.473 3.473 0 01-.348-1.681c.092-2.003 1.62-3.303 3.487-3.286 1.912.018 3.411 1.549 3.504 3.29a3.38 3.38 0 01-.338 1.657l-3.16 5.085-3.145-5.065zM17.5 9c-1.288-.012-2.39.425-3.184 1.2-.795.776-1.255 1.86-1.311 3.082a4.56 4.56 0 00.462 2.218l4.028 6.5 4.05-6.525a4.473 4.473 0 00.449-2.197C21.869 10.951 19.904 9.022 17.5 9zm1 4.711c0 .578-.448 1.047-1 1.047s-1-.469-1-1.047.448-1.047 1-1.047 1 .469 1 1.047zm1 0c0 1.156-.895 2.094-2 2.094s-2-.938-2-2.094.895-2.094 2-2.094 2 .938 2 2.094z"
        fill="currentColor"
      />
      <path
        d="M21.443 13.184l.005-.009.005-.01-.18-.087.17.106zM17.633 12.376l.039-.196-.04.196zM21.013 12.942l.006-.01.005-.01-.18-.086.17.106z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 13h7v4H2v-4zm1 1v2h5v-2H3zM2 18h7v4H2v-4zm1 1v2h5v-2H3z"
        fill="currentColor"
      />
      <path
        d="M20.998 4v2H6.373l1.25 1h14.375V3H2.626l-.001.002L3.873 4h17.125zM2.187 3.648l-.624.781.436.35V7h2.777l1.25 1H2v4h7v-1.621l13.019 10.415.625-.78L2.187 3.648zM3 6v-.42l.526.42H3zm5 5H3V9h4.276L8 9.579V11z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcTableColumnLocationsHidden;
